import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IfHasRenderInSourcesDirective, RenderInService } from 'common-ui';
import { ProductTypes } from 'products-data';
import { ItemResultHostComponentBase } from '../ItemResultHostComponentBase';
import { RenderTargetComponents } from './render-targets/RenderTargetComponents';

@Component({
  selector: 'ideal-item-result-layout',
  imports: [RenderTargetComponents, IfHasRenderInSourcesDirective, NgComponentOutlet],
  standalone: true,
  templateUrl: './item-result-layout.component.html',
  styleUrl: './item-result-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RenderInService],
})
export class ItemResultLayoutComponent extends ItemResultHostComponentBase {
  private readonly _renderIn = inject(RenderInService);

  /** The info area (title + important info) only exists when something is registered for one of its targets. */
  protected readonly hasInfo = computed(() =>
    [this.LayoutComponents[this.LayoutTargets.Title], this.LayoutComponents[this.LayoutTargets.ImportantInfo]].some(
      (target) => this._renderIn.getSources(target)().length > 0,
    ),
  );

  /** Standard items render as a plain row: no outline, no inner padding. */
  protected readonly standard = computed(() => this.productType() !== ProductTypes.Wire);

  /** Only wire items get the one-line (info | price | qty | stock) layout when the row is wide. */
  protected readonly singleLine = computed(() => this.productType() === ProductTypes.Wire);

  protected readonly componentInputs = computed(() => ({
    itemId: this.itemId(),
  }));
}
